const CHUNK_RELOAD_KEY = "chunk_reload";
const RELOAD_COOLDOWN_MS = 10000;

function isChunkLoadError(value) {
  const message =
    (typeof value === "string" && value) ||
    value?.message ||
    value?.reason?.message ||
    value?.error?.message ||
    "";
  return (
    message.includes("ChunkLoadError") ||
    message.includes("Loading chunk") ||
    message.includes("Loading CSS chunk") ||
    message.includes("Failed to fetch dynamically imported module")
  );
}

function reloadOnce() {
  try {
    const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
    if (last && Date.now() - last < RELOAD_COOLDOWN_MS) return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    window.location.reload();
  } catch {
    window.location.reload();
  }
}

/** Call once at app boot. Reloads once on stale chunk errors after deploy. */
export function setupChunkLoadRecovery() {
  window.addEventListener("error", (event) => {
    if (isChunkLoadError(event) || isChunkLoadError(event?.message) || isChunkLoadError(event?.error)) {
      reloadOnce();
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(event) || isChunkLoadError(event?.reason)) {
      reloadOnce();
    }
  });
}

export function isChunkRouteError(error) {
  return isChunkLoadError(error);
}

export function forceAppReload() {
  try {
    sessionStorage.removeItem(CHUNK_RELOAD_KEY);
  } catch {
    /* ignore */
  }
  window.location.reload();
}
